module monitoringApp.components {
    //@ts-ignore
    class ReportStackChartComponentController implements ng.IComponentController {

        private axisXLabel: string;
        private axisYLabel: string;
        private passedData: Array<[number, number]> = [];
        private failedData: Array<[number, number]> = [];
        private runsData: Array<[number, number]> = [];

        constructor(private $timeout) {
            this.stackOptions.chart.xAxis.axisLabel = this.axisXLabel;
            this.stackOptions.chart.yAxis.axisLabel = this.axisYLabel;
        }

        $inject = ['$timeout'];

        private stackData = () => {
            return [
                {
                    values: this.passedData,
                    key: 'Passed',
                    color: '#4CAF50'
                },
                {
                    values: this.failedData,
                    key: 'Failed',
                    color: '#f7464a'
                }

            ];
        }



        public stackOptions = {
            chart: {
                type: 'multiBarChart',
                height: 450,
                margin: {
                    top: 20,
                    right: 20,
                    bottom: 45,
                    left: 55
                },
                clipEdge: true,
                x: function (d) { return d[0]; },
                y: function (d) { return d[1]; },
                //staggerLabels: true,
                duration: 500,
                stacked: true,
                xAxis: {
                    axisLabel: "",
                    showMaxMin: false,
                    tickFormat: function (d) {
                        return d3.format('d')(d);
                    },
                    ticks: 31
                },
                yAxis: {
                    axisLabel: "",
                    axisLabelDistance: -10,
                    tickFormat: function (d) {
                        return d3.format('d')(d);
                    }
                },
                callback: (chart) => {
                    chart.reduceXTicks(false);
                    this.refreshCharts();
                },
                tooltip: {
                    valueFormatter: function (d, i) {
                        return d.toFixed(2) + '%';
                    }
                }

            }
        };



        private refreshCharts = () => {
            this.$timeout(function () {
                window.dispatchEvent(new Event('resize'));
            }, 0);
        }




    }


    class ReportStackChart implements ng.IComponentOptions {

        public bindings: { [binding: string]: string } = {
            axisYLabel: "@",
            axisXLabel: "@",
            failedData: "=",
            passedData: "="
        }

        public controller = ReportStackChartComponentController;

        constructor() {
        }

        public template =
        ` <nvd3 options="$ctrl.stackOptions" data="$ctrl.stackData" class="with-3d-shadow with-transitions"></nvd3>`;

    }

    angular.module("ultimateMonitoringApp").component("reportStackChart", new ReportStackChart());
}
